import ROUTES from 'routes';
import { pathFromRoute } from 'utils';
import api from './client';
import { cancelable, apifyPath } from './utils';

export function uploadFile ({ file, category = 'attachment' }, onUploadProgress) {
  const data = new FormData();
  data.append('file', file);
  data.append('category', category);

  return cancelable({
    url: pathFromRoute(ROUTES.API.FILES),
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
}

export function getFileUrl (id, fileName) {
  return encodeURI(apifyPath(pathFromRoute(ROUTES.API.FILES, { id, fileName })));
}

export function getFileInfo (id) {
  return api.get(pathFromRoute(ROUTES.API.FILES_INFO, { id }));
}

export function deleteFile (id) {
  return api.delete(pathFromRoute(ROUTES.API.FILES, { id }));
}
